module.exports = __webpack_public_path__ + "static/famr.us_certifications_wosb-2fa7400929a4ad773d2e9631c78759ef.jpg";